/** Contadores de la nav sin endpoint (semilla del canon F6, hoy.html) y fallback cuando la consulta falla sin datos. */
export const NAV_SEED = { skills: 14, conocimiento: 86, capacidades: 6, implantaciones: 23, cola: 7, alertas: 2, equipo: 4 } as const;
/** Etiquetas humanas de los app roles de Entra (el claim trae identificadores). */
export const ROLE_LABEL: Record<string, string> = { "Studio.Curator": "curadora", "Studio.Admin": "admin", "Library.Sign": "socio" };
